import { useEffect, useState } from "react";
import { Badge } from "@/components/ui/badge";
import type { Quote } from "@/lib/types";
import { fmtRelativeTime } from "@/lib/format";
import { cn } from "@/lib/utils";

const STATE_LABEL: Record<Quote["marketState"], string> = {
  REGULAR: "Marknad öppen",
  PRE: "Förhandel",
  POST: "Efterhandel",
  CLOSED: "Marknad stängd",
};

export function LiveBadge({ connected, quote }: { connected: boolean; quote: Quote | null }) {
  // Tick every 15s so the relative time stays fresh.
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 15_000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <span className="flex items-center gap-1.5">
        <span
          className={cn(
            "size-2 rounded-full",
            connected ? "bg-emerald-500 animate-pulse" : "bg-zinc-500",
          )}
        />
        {connected ? "Live" : "Återansluter…"}
      </span>
      {quote && (
        <>
          <Badge variant={quote.marketState === "REGULAR" ? "success" : "secondary"}>
            {STATE_LABEL[quote.marketState]}
          </Badge>
          <span>Uppdaterad {fmtRelativeTime(quote.fetchedAt)}</span>
          <span className="opacity-60">via {quote.source}</span>
        </>
      )}
    </div>
  );
}
